var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269.36 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10{fill:#6c63ff;}.cls-1,.cls-14,.cls-7{opacity:0.1;}.cls-1,.cls-3,.cls-7{isolation:isolate;}.cls-2{fill:#2f2e41;}.cls-3,.cls-8{opacity:0.2;}.cls-4{fill:#ff9064;}.cls-5{fill:#656478;}.cls-6{fill:#fbbebe;}.cls-9{fill:#3f3d56;}.cls-11{fill:#434175;}.cls-12{fill:#bdccd4;}.cls-13{fill:#a6a6ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.36,98a42.51,42.51,0,0,1-6.15,22.1c0,8.15-3.8,15.54-10,20.92a34.08,34.08,0,0,1-5,3.6l-.22.13-.4.24-.12.07h0c-.56.32-1.14.62-1.72.91a39,39,0,0,1-17.37,4H51.13q-2.12,0-4.2-.17a49.72,49.72,0,0,1-14.38-3.33q-1.35-.53-2.64-1.14l-1.22-.6-.75-.39a44.85,44.85,0,0,1-4.39-2.67,43.3,43.3,0,0,1-3.72-2.85c-8-6.88-13-16.39-13-26.89A42.5,42.5,0,0,1,0,88.72C0,65.38,18.66,46.46,41.68,46.46c.71,0,1.41,0,2.12.06h.3a71.8,71.8,0,0,1,15.3-18C76.41,13.92,101.27,4.73,129,4.73c23.27,0,44.54,6.49,60.83,17.2A41,41,0,0,1,210,16.62c23,0,41.68,18.92,41.68,42.27a43.53,43.53,0,0,1-.24,4.42A42.38,42.38,0,0,1,269.36,98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.42,64.51V62a9.19,9.19,0,1,0-6.92,0v2.53a13,13,0,0,0-6,3.66,13,13,0,0,0-7.32-5.3V60.33a9.19,9.19,0,1,0-6.92,0v2.53a13,13,0,0,0-5.46,3.1,13,13,0,0,0-6.92-4.75V58.68a9.19,9.19,0,1,0-6.92,0v2.53A13,13,0,0,0,161.83,65a13,13,0,0,0-8.61-7.78V54.68a9.19,9.19,0,1,0-6.92,0v2.53a13,13,0,0,0-9.42,11.25,12.86,12.86,0,0,0-3.9-1.83V64.1a9.19,9.19,0,1,0-6.92,0v2.53a13,13,0,0,0-8.16,6.76,12.85,12.85,0,0,0-3.53-1.58V69.28a9.19,9.19,0,1,0-6.92,0v2.53a12.78,12.78,0,0,0-3.35,1.46A13,13,0,0,0,96,66.63V64.1a9.19,9.19,0,1,0-6.92,0v2.53A13,13,0,0,0,80.64,74a13,13,0,0,0-4.41-2.2V69.28a9.19,9.19,0,1,0-6.92,0v2.53a13,13,0,0,0-9.49,12.48v58.39H85.7V137.5H97.95v5.18h25.9V137.5h18.6v-9.42h16v4h19.31v1.65H198v1.65h25.9V77A13,13,0,0,0,214.42,64.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.56,39.79h21.53a40.09,40.09,0,0,1,40.1,40.09h0v54.32H75.46V79.88a40.09,40.09,0,0,1,40.09-40.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.91,42h16.82a40.09,40.09,0,0,1,40.1,40.09h0v50h-97v-50A40.09,40.09,0,0,1,117.91,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.81,141.88V146a39,39,0,0,1-17.37,4H51.13q-2.12,0-4.2-.17a49.72,49.72,0,0,1-14.38-3.33q-1.35-.53-2.64-1.14l-1.22-.6-.75-.39a44.85,44.85,0,0,1-4.39-2.67V130.53a6.8,6.8,0,0,1,6.8-6.8H226.07a6.8,6.8,0,0,1,4.47,1.69l12.95,11.35A6.8,6.8,0,0,1,245.81,141.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.65,53.17q-7.7.51-15.34,1.65a14.53,14.53,0,0,0-4.24,1.1,12.43,12.43,0,0,0-2.81,2A37.06,37.06,0,0,0,82.3,70.06c-1.31,2.86-2.25,5.89-3.49,8.77-4.4,10.3-12.38,18.73-17,28.92a25.29,25.29,0,0,0-2.19,6.91c-.35,2.48,0,5.38,2.09,6.83a8.43,8.43,0,0,0,3.21,1.18,386.5,386.5,0,0,0,42.75,7,7.34,7.34,0,0,1-1.87-6,21.62,21.62,0,0,1,1.88-6.18q-12.2-2.69-24.34-5.65c-1.21-.29-2.66-.85-2.81-2.08a3.08,3.08,0,0,1,.54-1.79A95.87,95.87,0,0,1,93.39,90.54c0,6.61-.33,14.07-.33,20.68h76.31a58.39,58.39,0,0,1-1.61-11.5c-.36-12.66,3.91-25.22,2.8-37.85a7.67,7.67,0,0,0-.87-3.36c-1.05-1.72-3.15-2.44-5.08-3-7.4-2.25-15-4.53-22.7-4.35-2.3.05-4.59.32-6.88.59C128.06,52.54,120.65,52.7,113.65,53.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.91,129.1l5.56,17.78a.56.56,0,0,0,.53.39h23.84l-5.65-20.72-23.79,1.83a.56.56,0,0,0-.49.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.67,60.82a10.31,10.31,0,0,1-3.42,1l-7.6,1.32a8.45,8.45,0,0,0-4.17,1.53c-2.33,2-1.83,5.66-1.12,8.65l1.41,6c1.06,4.5,2.15,9.06,4.33,13.14,3.81,7.12,10.8,12.24,18.49,14.71a20.68,20.68,0,0,0,8.52,1.14c5.62-.62,10.42-4.62,13.39-9.44s4.37-10.4,5.66-15.9c1.24-5.27,2.42-10.61,2.34-16a9.31,9.31,0,0,0-1.09-4.88c-2-3.14-6.44-3.37-10.1-2.79a3.75,3.75,0,0,1-1.71,0c-1.65-.51-1.69-2.78-2.39-4.35-1.34-3-5.3-3.49-8.53-3.22s-8.28.61-11.1,2.45S121.85,59,118.67,60.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M118.67,60.82a10.31,10.31,0,0,1-3.42,1l-7.6,1.32a8.45,8.45,0,0,0-4.17,1.53c-2.33,2-1.83,5.66-1.12,8.65l1.41,6c1.06,4.5,2.15,9.06,4.33,13.14,3.81,7.12,10.8,12.24,18.49,14.71a20.68,20.68,0,0,0,8.52,1.14c5.62-.62,10.42-4.62,13.39-9.44s4.37-10.4,5.66-15.9c1.24-5.27,2.42-10.61,2.34-16a9.31,9.31,0,0,0-1.09-4.88c-2-3.14-6.44-3.37-10.1-2.79a3.75,3.75,0,0,1-1.71,0c-1.65-.51-1.69-2.78-2.39-4.35-1.34-3-5.3-3.49-8.53-3.22s-8.28.61-11.1,2.45S121.85,59,118.67,60.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.38,67.56a78.51,78.51,0,0,0,3.4,7.25,35.82,35.82,0,0,0,3.93,5c3.65,4.13,7.34,8.28,11.86,11.42a52.49,52.49,0,0,1,13-25.66c1.94-2.09,4.38-4.15,7.23-4.07a9.59,9.59,0,0,1,4.88,1.9,17.45,17.45,0,0,1,4.39,3.92,15.84,15.84,0,0,1,2.83,8.79,46.62,46.62,0,0,1-.82,9.32l-2.47,15.94a3.63,3.63,0,0,1-1.1,2.5,3.45,3.45,0,0,1-1.41.51c-9,1.75-18.25.61-27.41.53-10.12-.1-20.53,1.06-30.12-2.16a2.93,2.93,0,0,1-1.36-.77,2.84,2.84,0,0,1-.47-1c-2.23-7.23-.44-15,.88-22.46a176.21,176.21,0,0,0,2.24-17.84c0-.54,6,.65,6.63,1C110.32,62.76,111.51,65.75,112.38,67.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.29,126.39a2.8,2.8,0,0,1,0,.32q-1.35-.53-2.64-1.14a2.14,2.14,0,0,1-1.22-.6l-.75-.39a3.22,3.22,0,0,1,.19-.34,2.19,2.19,0,0,1,4,.12A4,4,0,0,1,39.29,126.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.42,122.36a4,4,0,0,1-.59,2,2.37,2.37,0,0,1-2,1.22h-.17a2.14,2.14,0,0,1-1.22-.6,3,3,0,0,1-.56-.73,4.13,4.13,0,0,1,.13-4,2.19,2.19,0,0,1,4,.12A4,4,0,0,1,39.42,122.36Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 37.03,
    cy: 118.25,
    rx: 3.3,
    ry: 2.52,
    transform: "translate(-82.34 151.53) rotate(-88.19)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 37.15,
    cy: 114.22,
    rx: 3.3,
    ry: 2.52,
    transform: "translate(-78.18 147.75) rotate(-88.19)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 37.28,
    cy: 110.19,
    rx: 3.3,
    ry: 2.52,
    transform: "matrix(0.03, -1, 1, 0.03, -74.03, 143.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M28.73,82.3a11.69,11.69,0,0,1-.89-1.41L34.48,80l-7.17-.17a12.1,12.1,0,0,1,.07-9.57l9.45,5.28-8.65-6.79a12.07,12.07,0,1,1,19.5,14.13A12,12,0,0,1,49,85.14l-8.73,4.2,9.26-2.79a12.09,12.09,0,0,1-2.31,11.28,12.07,12.07,0,1,1-19-.61A12.07,12.07,0,0,1,28.73,82.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50,90.44a12,12,0,0,1-2.83,7.38,12.07,12.07,0,1,1-19-.6C26.69,95.12,50.08,89.09,50,90.44Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.02,
    cy: 33.24,
    r: 5.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.24,
    cy: 5.09,
    r: 5.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.52,
    cy: 24.43,
    r: 8.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 127.85,
    cy: 43.68,
    r: 19.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M119.82,4.87c-5.28.67-11,1.55-14.7,5.34A20.79,20.79,0,0,0,100.8,18c-1.56,4.36-2.72,8.95-2.35,13.57.32,4.13,1.86,8.36.62,12.32A33.75,33.75,0,0,1,96.51,49a27.07,27.07,0,0,0-2.65,10.22,17.75,17.75,0,0,0,.64,7.23c.85,2.45,2.51,4.53,3.56,6.9,1.55,3.5,1.71,7.44,1.83,11.26s.22,7.63.31,11.44c.06,2.4.06,5-1.26,7,4.9-2,9.86-4,14-7.16s7.58-7.82,8.12-13.07c.44-4.25-1-8.44-2.24-12.54-3.06-10.12-5-20.92-2.81-31.26.8-3.72,2.75-7.88,6.5-8.56,2.29-.42,4.57.63,6.63,1.7,4.87,2.55,9.89,5.84,11.7,11,1.65,4.69.26,9.91-1.88,14.39s-5.06,8.6-6.73,13.28a24.89,24.89,0,0,0,2.41,21.92c4.25,6.33,12.11,10.22,19.66,9.2-.59-2.55-2.44-4.61-3.44-7-1.81-4.41-.59-9.47,1.35-13.82s4.59-8.4,5.81-13a38.93,38.93,0,0,0,1-10c0-5.29-.26-10.58-.77-15.84a71.69,71.69,0,0,0-3-15.66,29.63,29.63,0,0,0-6.24-11.1c-3.12-3.32-7.19-5.57-11.18-7.77a25.5,25.5,0,0,0-7.51-3.14,40.67,40.67,0,0,0-6.51-1A5.5,5.5,0,0,0,119.82,4.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 130.82,
    y: 38.38,
    width: 33.37,
    height: 14.33,
    rx: 0.68,
    ry: 0.68,
    transform: "translate(74.7 181.67) rotate(-79.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 131.78,
    y: 38.56,
    width: 33.37,
    height: 14.33,
    rx: 0.68,
    ry: 0.68,
    transform: "translate(75.3 182.76) rotate(-79.02)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 150.25,
    cy: 36.44,
    rx: 2.37,
    ry: 0.98,
    transform: "translate(85.86 177) rotate(-79.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.22,47.33a8.21,8.21,0,0,0-2.33-2.94,8.24,8.24,0,0,0-1.93-.86,25.6,25.6,0,0,0-7-1.73,1.32,1.32,0,0,0-1.1.3c-.53.62.31,1.46,1,1.84l5.75,3-5.3-.56c-.77-.08-1.87.13-1.81.9,0,.51.59.78,1.07.94,3.4,1.18,7.33,2.1,9.2,5.18a23.8,23.8,0,0,0-7.45.08,3.15,3.15,0,0,0-1.79.91,1.32,1.32,0,0,0,.06,1.83,1.85,1.85,0,0,0,1.22.24c1.73-.08,3.5-.43,5.15.07s3.13,2.23,2.56,3.86a9.3,9.3,0,0,0,4.57-.63c1.5-.71,1.46-2,1.37-3.64C157.28,52.94,155.73,50,154.22,47.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M152.74,98.65a264.93,264.93,0,0,0-5.42-27.53c-1.18-4.71-2.51-9.5-2.18-14.34,4.86.62,9.22,1.08,13.71-.91.07,2.55,1.92,4.71,2.59,7.17a31.55,31.55,0,0,1,.46,5.09,31.2,31.2,0,0,0,1.16,5,61.27,61.27,0,0,1,1.56,25.13C160.46,98.75,156.89,99.3,152.74,98.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152,98.65a264.93,264.93,0,0,0-5.42-27.53c-1.18-4.71-2.51-9.5-2.18-14.34,4.86.62,9.22,1.08,13.71-.91.07,2.55,1.92,4.71,2.59,7.17a31.55,31.55,0,0,1,.46,5.09,31.2,31.2,0,0,0,1.16,5,61.27,61.27,0,0,1,1.56,25.13C159.75,98.75,156.18,99.3,152,98.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84,144.51l2.31-57.18A3.5,3.5,0,0,1,89.81,84l91,.87a3.5,3.5,0,0,1,3.46,3.53q0,.14,0,.27l-4.81,54.78a3.5,3.5,0,0,1-3.43,3.19l-88.5,1.53A3.5,3.5,0,0,1,84,144.71Q84,144.61,84,144.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 134.8,
    cy: 109.96,
    rx: 4,
    ry: 4.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M220.38,106.72l-.19,1.62-3.06,26.1c-8,5.56-14.19.22-14.24,0L199,108.21l-.22-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M220.38,106.72l-.19,1.62c-9,5.23-18.58,1.16-21.16-.12l-.22-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M198.37,105.3v2.35s11.89,6.91,22.6,0V105.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M199.75,102.19s-.35,1.59-1.38,1.73v2H221v-1.8a1.67,1.67,0,0,1-1.18-1.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 209.6,
    cy: 102.37,
    rx: 10.2,
    ry: 2.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 209.6,
    cy: 102.37,
    rx: 10.2,
    ry: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M218.55,102.19c0,1.18-3.87,2.14-8.64,2.14h-.25a20,20,0,0,1-7.39-1.14c-.64-.3-1-.64-1-1,0-.6,1-1.14,2.59-1.53a26.72,26.72,0,0,1,6.06-.61C214.69,100.05,218.55,101,218.55,102.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.66,104.34a20,20,0,0,1-7.39-1.14h0l1.58-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.63,102.36c-.12,0-.28,0-.31.14a.3.3,0,0,0,0,.18,2.51,2.51,0,0,0,1.13,1,.67.67,0,0,0,.26.08.24.24,0,0,0,.24-.12.27.27,0,0,0,0-.22,1,1,0,0,0-.29-.32C201.36,102.81,201,102.43,200.63,102.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 209.95,
    cy: 121.44,
    r: 6.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.34,121.46h2.85a5.89,5.89,0,0,1,5.89,5.89v8.75H38.46v-8.75A5.89,5.89,0,0,1,44.34,121.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44.34,121.46h2.85a5.89,5.89,0,0,1,5.89,5.89v8.75H38.46v-8.75A5.89,5.89,0,0,1,44.34,121.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 123.51,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 122.04,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 120.58,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 119.12,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 117.66,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 116.19,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 114.73,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 46.94,
    cy: 115.32,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 48.11,
    cy: 114.73,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 49.28,
    cy: 114.14,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 113.27,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 111.81,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 110.34,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 45.18,
    cy: 108.88,
    r: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M50,105.11c-.29,0-.58.07-.87.09a6.73,6.73,0,0,0,.76-.78,5,5,0,0,0-.71-1.37,2.41,2.41,0,0,1-.94.3c-.29,0-.58.07-.87.09a14.59,14.59,0,0,0,1.12-1.18,5,5,0,1,0,1.56,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M53.94,110.92a2.28,2.28,0,0,1-1,.33c-.29,0-.58.08-.87.09a8.57,8.57,0,0,0,.87-.9,2.93,2.93,0,1,0,1,.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 43.43,
    cy: 115.32,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 42.26,
    cy: 114.73,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 41.09,
    cy: 114.14,
    r: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M36.42,110.92a2.27,2.27,0,0,0,1,.33c.29,0,.58.08.87.09a8.34,8.34,0,0,1-.87-.9,2.93,2.93,0,1,1-1,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.34,122.34h2.85a5.89,5.89,0,0,1,5.89,5.89V136a1,1,0,0,1-1,1H39.45a1,1,0,0,1-1-1v-7.74A5.89,5.89,0,0,1,44.34,122.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.12,105.43a4.43,4.43,0,0,1-.38.36,3.83,3.83,0,0,0,.4,0A2.1,2.1,0,0,0,50.12,105.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,104c.29,0,.58,0,.88-.09a2.83,2.83,0,0,0,.76-.21,5,5,0,0,0-.41-.68,1.77,1.77,0,0,1-.47.2A6.78,6.78,0,0,1,48,104Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8,106.54a5,5,0,0,1,7.65-4.18l.08-.08a5,5,0,1,0-6.61,7.42l.05,0A4.94,4.94,0,0,1,40.8,106.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.09,111.93c.29,0,.58,0,.87-.09a2.28,2.28,0,0,0,1-.33,2.93,2.93,0,0,1,1.18,2.07,2.68,2.68,0,0,0,0-.31A2.91,2.91,0,0,0,54,110.91a2.28,2.28,0,0,1-1,.33l-.24,0A6,6,0,0,1,52.09,111.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2,110.93l.29,0,.46-.51a2.92,2.92,0,0,0-3.67,2.83,2,2,0,0,0,0,.29A2.92,2.92,0,0,1,52.2,110.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.28,111.93c-.29,0-.58,0-.87-.09a2.27,2.27,0,0,1-1-.33,2.93,2.93,0,0,0-1.18,2.07,2.68,2.68,0,0,1,0-.31,2.91,2.91,0,0,1,1.18-2.35,2.27,2.27,0,0,0,1,.33l.24,0A5.57,5.57,0,0,0,38.28,111.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.16,110.93l-.29,0-.45-.51a2.92,2.92,0,0,1,3.67,2.83,2,2,0,0,1,0,.29A2.92,2.92,0,0,0,38.16,110.93Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxContact);
export default __webpack_public_path__ + "static/media/gfx-contact.dad4c8f4db6c35cfcc3ec0c363b2ac26.svg";
export { ForwardRef as ReactComponent };